import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import apiClient from './axiosConfig';
import { navigateTo } from './platform';

let listenersAttached = false;
let lastRegisteredToken = null;

async function registerTokenWithBackend(token, platformName) {
  await apiClient.post('/push/register', { token, platform: platformName });
}

async function unregisterTokenWithBackend(token) {
  try {
    await apiClient.delete('/push/unregister', { data: { token } });
  } catch {
    /* ignore if already logged out */
  }
}

function handleNotificationNavigation(data) {
  const target = data?.path || data?.url;
  if (!target) return;
  if (target.startsWith('http')) {
    window.open(target, '_self');
    return;
  }
  navigateTo(target.startsWith('/') ? target : `/${target}`);
}

function attachPushListeners() {
  if (listenersAttached || !Capacitor.isNativePlatform()) return;
  listenersAttached = true;

  PushNotifications.addListener('registration', async (token) => {
    lastRegisteredToken = token.value;
    try {
      await registerTokenWithBackend(token.value, Capacitor.getPlatform());
    } catch (err) {
      console.warn('Failed to register push token:', err);
    }
  });

  PushNotifications.addListener('registrationError', (err) => {
    console.warn('Push registration error:', err);
  });

  PushNotifications.addListener('pushNotificationReceived', () => {
    /* foreground — OS shows banner */
  });

  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
    handleNotificationNavigation(action.notification?.data);
  });
}

export async function initPushNotifications() {
  if (!Capacitor.isNativePlatform()) return;

  attachPushListeners();

  let permStatus = await PushNotifications.checkPermissions();
  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions();
  }
  if (permStatus.receive !== 'granted') return;

  await PushNotifications.register();
}

export async function teardownPushNotifications() {
  if (!Capacitor.isNativePlatform() || !lastRegisteredToken) return;

  const token = lastRegisteredToken;
  lastRegisteredToken = null;
  await unregisterTokenWithBackend(token);
}
